import React from 'react';
import PropTypes from 'prop-types';
import { createVariants } from './_variants';

const cardClasses = createVariants({
  base:
    'bg-succession-bg-primary text-succession-text-primary border border-succession-border rounded-lg shadow-succession-md transition-theme duration-theme',
  variants: {
    elevated: 'shadow-succession-lg',
    outlined: 'bg-succession-bg-primary',
    subtle: 'bg-succession-bg-secondary',
    // Borderless/plain surface (no shadow by default)
    plain: 'bg-succession-bg-primary border-0 shadow-none',
    borderless: 'bg-succession-bg-primary border-0 shadow-none',
    // Brand-filled surfaces using theme colors
    brandPrimary: 'text-white',
    brandSecondary: 'text-white',
    brandAccent: 'text-white',
  },
  sizes: {
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
  },
  defaultVariant: 'outlined',
  defaultSize: 'md',
});

const Card = ({ as: Comp = 'div', variant = 'outlined', size = 'md', className, children, style, ...rest }) => {
  let classes = cardClasses({ variant, size, className });
  // Inline style overrides for brand-filled variants ensure background color wins over base class
  let styleOverride = style || {};
  if (variant === 'brandPrimary') {
    styleOverride = { backgroundColor: 'var(--succession-primary)', color: '#ffffff', ...styleOverride };
  } else if (variant === 'brandSecondary') {
    styleOverride = { backgroundColor: 'var(--succession-secondary)', color: '#ffffff', ...styleOverride };
  } else if (variant === 'brandAccent') {
    styleOverride = { backgroundColor: 'var(--succession-accent)', color: '#ffffff', ...styleOverride };
  }
  // Remove default bg/text classes that are marked !important in Tailwind so brand variants don't get overridden
  if (variant === 'brandPrimary' || variant === 'brandSecondary' || variant === 'brandAccent') {
    classes = classes
      .replace(/\bbg-succession-bg-primary\b/g, '')
      .replace(/\btext-succession-text-primary\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }
  return (
    <Comp className={classes} style={styleOverride} {...rest}>
      {children}
    </Comp>
  );
};

Card.propTypes = {
  as: PropTypes.elementType,
  variant: PropTypes.oneOf(['elevated', 'outlined', 'subtle', 'plain', 'borderless', 'brandPrimary', 'brandSecondary', 'brandAccent']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Card;


